import script from "./ChangeUnlockKeyOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeUnlockKeyOverlay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QForm});
